export const API_URL = process.env.REACT_APP_API_URL;

export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';

export const ROOT_URL = process.env.REACT_APP_ROOT_URL;
